export const PAGES = {
    pageIndex: 0,
    pageSize: 10,
}

export const TopBannerJson = [
    { "id": 1, "display_name": "Image" },
    { "id": 2, "display_name": "Video" },
]
export const DrugFeeJson = [
    { "id": 1, "display_name": "Yes" },
    { "id": 2, "display_name": "No" },
]